/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateMeAvatarRequestUserFromJSON, UpdateMeAvatarRequestUserToJSON } from './UpdateMeAvatarRequestUser';
export function UpdateMeAvatarRequestFromJSON(json) {
    return UpdateMeAvatarRequestFromJSONTyped(json, false);
}
export function UpdateMeAvatarRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        user: !exists(json, 'user') ? undefined : UpdateMeAvatarRequestUserFromJSON(json['user'])
    };
}
export function UpdateMeAvatarRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user: UpdateMeAvatarRequestUserToJSON(value.user)
    };
}
